const Env = () => {
    return {
        API_URL: process.env.REACT_APP_API_URL || 'https://depot.uam.sn/api/v1',
        ANNEE_UNIVERSITE: process.env.REACT_APP_ANNEE_UNIVERSITE || '2025-2026',
    };
};

export default Env;
